import React, { ReactNode } from 'react';
import { Flex, useDisclosure } from '@chakra-ui/react';

import NavBar from '@/components/0-reusable-components/navigation/admin-navbar/drawer/navbar';
import NavigationDrawer from '@/components/0-reusable-components/navigation/admin-navbar/drawer/navigation-drawer';

export interface IProps {
  children: ReactNode;
  showBackButton?: boolean;
  noPadding?: boolean;
}

const SecretariaLayout = ({ children, showBackButton, noPadding }: IProps): React.ReactElement => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const NAVBAR_HEIGHT = 56;
  const LAYOUT_PADDING = noPadding ? 0 : 32;

  return (
    <>
      <NavBar isOpen={isOpen} onClose={onClose} onOpen={onOpen} showBackButton={!!showBackButton} />
      <NavigationDrawer isOpen={isOpen} onClose={onClose} />

      <Flex direction='column' p={`${LAYOUT_PADDING}px`} minH={`calc(100vh - ${NAVBAR_HEIGHT}px)`}>
        {children}
      </Flex>
    </>
  );
};

export default SecretariaLayout;
